<template>
	<div class="main-header">
		<!-- <a style="width:100%;display:block;" href="http://www.gov.cn/zhuanti/zggcddescqgdbdh/index.htm" target="_blank">
            <img style="display:block;width:100%;" src="../../assets/imgs/newbanner.png" alt="">
        </a> -->
		<div class="header">
			<div class="header-topbox">
				<div class="header-top-main-box">
					<!-- <img
						class="headerBg"
						src="../../assets/imgs/homebg.png"
						alt=""
					/> -->
					<div class="header-top-sm-box">
						<div
							class="header-top-search-button"
							@click="searchBtnFn"
						>
							<img src="../../assets/imgs/input.png" alt="" />
						</div>
						<el-input
							class="header-top-search-box"
							@keyup.enter.native="searchBtnFn"
							v-model="searchVal"
							placeholder="请输入内容"
						></el-input>
						<!-- <a class="header-top-words_back" href="http://archive.cikd.org/" target="_blank">返回旧版</a> -->
						<a
							class="header-top-words_button"
							href="http://en.cikd.org/"
							target="_blank"
							>English</a
						>
						<!-- <a class="header-top-words_button" href="http://archive.cikd.org/english/" target="_blank">English</a> -->
						<span class="header-top-split">|</span>
						<a
							class="header-top-words_button active"
							href="javascript:void(0);"
							>中文</a
						>
					</div>
					<img
						class="header-top-left-logo"
						src="../../assets/imgs/logo3.png"
						alt="中国国际发展知识中心"
					/>
					<a target="_blank" href="http://www.gsrc-web.net/cn">
						<img
							class="header-top-left-logo topLogo4"
							style=""
							src="../../assets/imgs/southernStudies/logo_nf.png"
							alt="全球南方研究中心"
						/>
					</a>
				</div>
				<a
					class="pageTitle"
					href="/aboutus?pid=1828311428746067970&menuId=1838387784930443265"
					target="_blank"
					>习近平总书记九次重要指示</a
				>
			</div>
			<div class="header-underbox">
				<div class="header-underbox-nav-box">
					<a
						:class="
							curActive == -1
								? 'header-underbox-nav active'
								: 'header-underbox-nav'
						"
						href="/"
						>首页</a
					>
					<!-- <a
						class="header-underbox-nav"
						target="_blank"
						href="https://preview.shorthand.com/y79yDQPJM8McWUXu/responsive/desktop"
						>全球南方研究中心</a
					> -->
					<div
						class="header_hoverDivBox_main"
						v-for="(item, i) in menuList"
						:key="i"
						v-if="item.categoryKeyword !== 'nonav'"
						@mouseenter="headerHoverFn(1, i)"
						@mouseleave="headerHoverFn(2, i)"
						style="
							display: inline-block;
							float: left;
							position: relative;
						"
					>
						<!-- 顶级导航 -->
						<a
							:class="
								curActive != -1
									? curActive == i
										? 'header-underbox-nav active'
										: 'header-underbox-nav'
									: 'header-underbox-nav'
							"
							:href="
								item.categoryTitle == '全球南方研究中心'
									? 'http://www.gsrc-web.net/cn'
									: 'javascript:void(0);'
							"
							:target="
								item.categoryTitle == '全球南方研究中心'
									? '_blank'
									: ''
							"
						>
							{{ item.categoryTitle }}
						</a>

						<!-- 子菜单 -->
						<div
							v-if="
								item.categoryKeyword !== 'nomenu' &&
								item.childrenList &&
								item.childrenList.length > 0
							"
							class="header_hoverDivBox"
						>
							<a
								class="header_hoverDivBox_item"
								v-for="(sitem, j) in item.childrenList"
								:key="j"
								:href="`${
									item.id == '1828311428746067970'
										? '/aboutus'
										: sitem.id == '1873548222512922625'
										? 'http://www.gsrc-web.net/cn'
										: '/special'
								}?pid=${sitem.categoryId}&menuId=${sitem.id}`"
							>
								{{ sitem.categoryTitle }}
							</a>
							<img src="../../assets/imgs/header_bg.png" alt="" />
						</div>
					</div>

					<!-- <a class="header-underbox-nav" href="javascript:void(0);">新闻动态</a>
                <a class="header-underbox-nav" href="javascript:void(0);">研究项目</a>
                <a class="header-underbox-nav" href="javascript:void(0);">交流传播</a>
                <a class="header-underbox-nav" href="javascript:void(0);">知识产品</a>
                <a class="header-underbox-nav" href="javascript:void(0);">培训咨询</a>
                <a class="header-underbox-nav" href="javascript:void(0);">关于我们</a> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import $ from 'jquery';
import { getTopMenuList } from '../../api/home.js';

export default {
	name: 'index',
	data() {
		return {
			searchVal: '',
			menuList: [], //获取栏目列表
			curActive: -1,
		};
	},
	mounted() {
		//console.log(this.$store.state);

		this.fetchData();
		////console.log(this.$route, 'this.$router.query.pid');
		if (this.$route.name == 'aboutUs') {
			this.curActive = 5;
		} else if (
			this.$route.name == 'detail' ||
			this.$route.name == 'searchpage'
		) {
			this.curActive = -2;
		} else {
			switch (this.$route.query.pid) {
				case '1828310500999577601':
					this.curActive = 0;
					break;
				case '1828310633946431489':
					this.curActive = 1;
					break;
				case '1828310733133332482':
					this.curActive = 2;
					break;
				case '1828310842516586497':
					this.curActive = 3;
					break;
				case '1828311428746067970':
					this.curActive = 4;
					break;
				default:
					this.curActive = -1;
					break;
			}
		}
	},
	methods: {
		fetchData() {
			let _this = this;
			let menuId = '1828310133012316161';
			let onlyChild = false;
			let paltformId = '1828310133012316161';
			getTopMenuList({
				menuId: menuId,
				onlyChild: onlyChild,
				paltformId: paltformId,
			}).then((res) => {
				if (res.data.data) {
					_this.menuList = res.data.data.childrenList;
					console.log(_this.menuList);
				}
			});
		},
		//鼠标hover显示下拉框
		//num 1:hover,2:leave
		headerHoverFn(num, index) {
			if (num == 1) {
				// 移除所有 active
				$('.header_hoverDivBox_main .header_hoverDivBox').removeClass(
					'active'
				);

				// 找到当前 hover 的 .header_hoverDivBox_main
				const $current = $('.header_hoverDivBox_main').eq(index);

				// 如果里面有 .header_hoverDivBox，就加 active
				const $hoverBox = $current.find('.header_hoverDivBox');
				if ($hoverBox.length > 0) {
					$hoverBox.addClass('active');
				}
			}

			if (num == 2) {
				$('.header_hoverDivBox_main .header_hoverDivBox').removeClass(
					'active'
				);
			}
		},
		//点击搜索按钮
		searchBtnFn() {
			if (!this.searchVal) {
				this.$message('请输入搜索内容！');
			} else {
				window.location.href = '/searchpage?keyword=' + this.searchVal;
			}
		},
	},
};
</script>

<style scoped lang="less">
.main-header {
	width: 100%;
	/* height: 100%; */
}
/* 头部 */
.header {
	width: 100%;
	height: 259px;
	/* background: linear-gradient(90deg, #2164C8, #1B99C6); */
	background: #0072b5;
}
.header-topbox {
	width: 100%;
	height: 208px;
	width: 100%;
	border-bottom: 1px solid rgba(255, 255, 255, 0.2);
	background: #fff;
}
.header-top-main-box {
	width: 1366px;
	height: 132px;
	margin: 0 auto;
	position: relative;
	border-top: 1px solid rgba(0, 0, 0, 0);
}
.header-top-left-logo {
	// width: 317px;
	// height: 129px;
	position: absolute;
	top: 33px;
	left: 0;
}
.topLogo4 {
	top: 34px;
	left: 356px;
	//	width: 392px;
	cursor: pointer;
}
.headerBg {
	position: absolute;
	top: 4px;
	left: 35%;
}
.header-top-sm-box {
	width: 100%;
	height: 40px;
	margin-top: 64px;
}
.header-top-words_button {
	height: 40px;
	font-size: 15px;
	/* font-family: STXihei; */
	font-weight: 400;
	color: #9e9e9e;
	line-height: 40px;
	float: right;
}
.header-top-words_back {
	height: 40px;
	font-size: 15px;
	/* font-family: STXihei; */
	font-weight: 400;
	color: #1b70cb;
	line-height: 40px;
	float: right;
	margin-left: 30px;
}
.header-top-words_button.active {
	color: #1b70cb;
}
.header-top-split {
	height: 40px;
	font-size: 15px;
	/* font-family: STXihei; */
	font-weight: 400;
	color: #9e9e9e;
	line-height: 40px;
	margin: 0 8px;
	opacity: 0.23;
	float: right;
}
.header-top-search-box {
	width: 204px;
	height: 40px;
	background: #ffffff;
	border-radius: 0;
	margin-left: 30px;
	float: right;
}
.header-top-search-button {
	width: 48px;
	height: 40px;
	/* background: linear-gradient(90deg, #2FA82C, #14CC89); */
	background: #217ad5;
	border-radius: none;
	float: right;
	text-align: center;
	cursor: pointer;
}
.header-top-search-button img {
	width: 14px;
	height: 14px;
	margin: 13px auto 0;
}
.header-underbox {
	width: 1366px;
	height: 51px;
	margin: 0 auto;
	position: relative;
	display: flex;
	justify-content: space-evenly;
}
.header-underbox-nav {
	font-weight: 600;
	height: 51px;
	font-size: 20px;
	width: 195px;
	color: #ffffff;
	line-height: 51px;
	float: left;
	text-align: center;
	border-right: 1px solid #fff;
	/* margin-right: 64px; */
	// border-bottom: 3px solid rgba(0, 0, 0, 0);
}
.header_hoverDivBox_main:last-child {
	.header-underbox-nav {
		border-right: none;
	}
}
.header-underbox-nav:hover {
	background: #005998;
}
.header-underbox-nav.active {
	background: #005998;
	// border-bottom: 3px solid #208b32;
}
/* 分享部分 */
.header-underbox-share-box {
	position: absolute;
	top: 10px;
	right: 0;
}

.header_hoverDivBox {
	width: 195px;
	height: auto;
	background: #fff;
	position: absolute;
	top: 51px;
	left: 0;
	background: #f7fafe;
	box-shadow: 0px 2px 15px 0px rgba(14, 81, 151, 0.2);
	z-index: 100000;
	padding-top: 21px;
	display: none;
}
.header_hoverDivBox.active {
	display: block;
}
.header_hoverDivBox_item {
	width: 100%;
	display: block;
	text-align: center;
	color: rgb(51, 51, 51);
	font-size: 18px;
	color: #2c2c2c;
	line-height: 15px;
	text-overflow: ellipsis;
	display: -webkit-box;
	font-family: 微软雅黑 !important;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	margin-bottom: 27px;
	// padding-left: 28px;
}
.header_hoverDivBox_item:hover {
	color: #217ad5;
}
.header_hoverDivBox img {
	position: absolute;
	bottom: 0;
	left: 0;
	display: block;
	max-height: 100%;
	width: 100%;
	z-index: -1;
}
.pageTitle {
	display: block;
	font-family: 微软雅黑;
	font-size: 42px;
	color: #0072b5;
	font-weight: 600;
	text-align: center;
	margin-top: 10px;
	cursor: pointer;
}
.pageTitle:hover {
	color: #368ad2;
}
</style>
